/*
 * Copyright (C) 2005 - 2023. Cloud Software Group, Inc. All Rights Reserved. Confidential & Proprietary.
 * Licensed pursuant to commercial Cloud Software Group, Inc. End User License Agreement.
 */

import { IReducerAction, IReducerActionData } from '../store/types/ReducerTypes';

export const VisualizationActions = {
    VISUALIZATION_UPDATE_DYNAMIC_PROPERTIES: 'VISUALIZATION_UPDATE_DYNAMIC_PROPERTIES',
};

export function updateDynamicProperties(dynamicProperties: any): IReducerAction<IReducerActionData> {
    return {
        type: VisualizationActions.VISUALIZATION_UPDATE_DYNAMIC_PROPERTIES,
        data: { dynamicProperties }
    };
}
